"use client";

// Fehlerzustand: ein Satz, ein Knopf. Die technische Meldung bleibt
// auf dem Server (Next ersetzt sie im Produktionsbau ohnehin).
import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export default function BeitraegeFehler({ error, retry }: { error: unknown; retry: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  const kennung = error instanceof Error && "digest" in error ? String((error as Error & { digest?: string }).digest ?? "") : "";

  return (
    <EmptyState
      icon={AlertTriangle}
      title="Die Beiträge ließen sich nicht laden"
      description={kennung ? `Fehlerkennung ${kennung} — bitte melden, wenn es bleibt.` : "Bitte noch einmal versuchen."}
      action={<Button onClick={() => retry()}>Noch einmal</Button>}
    />
  );
}
